import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "@softmax/design-system";
import { colors } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import type { CreatorCoworldRow } from "./coworld-records";
import { coworldLayout } from "./coworld-layout.styles";
import { CoworldStatus } from "./coworld-status";

export function CoworldLibraryTable({
  rows,
}: Readonly<{ rows: readonly CreatorCoworldRow[] }>) {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableHeaderCell>Coworld</TableHeaderCell>
          <TableHeaderCell>Checks</TableHeaderCell>
          <TableHeaderCell>
            <span {...stylex.props(coworldLayout.secondaryColumn)}>
              Visibility
            </span>
          </TableHeaderCell>
          <TableHeaderCell align="end">
            <span {...stylex.props(coworldLayout.secondaryColumn)}>
              Uploaded
            </span>
          </TableHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => (
          <TableRow key={row.id}>
            <TableCell>
              <div {...stylex.props(styles.entry)}>
                <a href={row.href} {...stylex.props(coworldLayout.rowLink)}>
                  {row.name}
                  <span {...stylex.props(coworldLayout.muted)}>
                    {row.version}
                  </span>
                </a>
                <span {...stylex.props(coworldLayout.mobile)}>
                  {row.visibility} · {row.uploaded}
                </span>
              </div>
            </TableCell>
            <TableCell>
              <div {...stylex.props(coworldLayout.cell)}>
                <CoworldStatus {...row.checks} />
              </div>
            </TableCell>
            <TableCell>
              <span
                {...stylex.props(
                  coworldLayout.cell,
                  coworldLayout.secondaryColumn,
                )}
              >
                {row.visibility}
              </span>
            </TableCell>
            <TableCell align="end">
              <span
                {...stylex.props(
                  coworldLayout.cell,
                  coworldLayout.secondaryColumn,
                )}
              >
                <time
                  dateTime={row.uploadedAt}
                  title={new Date(row.uploadedAt).toLocaleString()}
                >
                  {row.uploaded}
                </time>
              </span>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

const styles = stylex.create({
  entry: {
    backgroundColor: {
      default: "transparent",
      ":hover": colors.hover,
      ":focus-within": colors.hover,
    },
  },
});
